import { Injectable } from '@angular/core';

export type RunnerLanguage = 'pt' | 'en';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly storageKey = 'castor.runner.lang';
  private _language: RunnerLanguage = this.loadInitial();

  get language(): RunnerLanguage {
    return this._language;
  }

  setLanguage(lang: RunnerLanguage): void {
    this._language = lang;
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(this.storageKey, lang);
      }
    } catch {
      // ignore storage errors
    }
  }

  private loadInitial(): RunnerLanguage {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const v = window.localStorage.getItem(this.storageKey);
        if (v === 'pt' || v === 'en') return v;
      }
    } catch {
      // ignore storage errors
    }
    return 'pt';
  }
}

